export default "__VITE_ASSET__Cf_76sQ7__"